import { Box, makeStyles } from '@material-ui/core';
import Slider, { Settings } from 'react-slick';
import { Testimonial } from 'store/url-builder';
import { TestimonialCarouselItem } from './testimonial-carousel-item';

export interface TestimonialCarouselProps {
 testimonials: Testimonial[];
 color: string;
 cardId: number;
 readonly?: boolean;
 builderType: string;
}

const useStyles = makeStyles(() => ({
 dots: {
  bottom: 0,
  '& li.slick-active button::before': {
   color: (props: any) => props.color + '!important',
  },
 },
}));

export const TestimonialCarousel = ({ testimonials, color, cardId, readonly, builderType }: TestimonialCarouselProps) => {
 const classes = useStyles({ color });
 const settings: Settings = {
  dots: true,
  infinite: false,
  slidesPerRow: 1,
  dotsClass: `slick-dots ${classes.dots}`,
  centerPadding: '150px',
 };
 return (
  <Box className='mb-4'>
   <Slider {...settings}>
    {testimonials.map((testimonial, idx) => (
     <Box key={idx} className='mb-3' position='relative'>
      <TestimonialCarouselItem readonly={readonly} testimonial={testimonial} color={color} cardId={cardId} idx={idx} builderType={builderType} />
     </Box>
    ))}
   </Slider>
  </Box>
 );
};
